(ns common.schema.data
  (:require
    [clojure.string :as string]
    [common.currencies :as currencies]
    [common.date-formats :as date-formats]
    [common.entity :as entity]
    [common.localization :as loc]
    [common.timezones :as timezones]
    [common.util :as cu]))

(defmulti _coerce
          (fn [field-schema _ _]
            (:field/data-type field-schema)))

(defmethod _coerce :default
  [field-schema value edn-reader]
  value)

(defmethod _coerce :data.type/text-simple
  [field-schema value edn-reader]
  (cond
    (string? value) (string/trim value)
    ;; TODO: do we ever want to accept any other than string values ?
    ;(entity/entity? value) (entity/display-string value)
    ;:default (str value)
    :default value))

(defmethod _coerce :data.type/text-multiline
  [field-schema value edn-reader]
  (cond
    (string? value) (string/trim value)
    :default value))

(defmethod _coerce :data.type/currency-value
  [field-schema value edn-reader]
  #?(:cljs (cond
             (number? value) value
             (string? value) (_coerce field-schema (edn-reader value) edn-reader)
             :default value)
     :clj  (cond
             (decimal? value) value                         ;; bigdecs are decimal
             (number? value) (or (and bigdec (bigdec value))
                                 value)                     ;; clojurescript does not support bigdec
             (string? value) (_coerce field-schema (edn-reader value) edn-reader)
             :default value)))

(defmethod _coerce :data.type/number
  [field-schema value edn-reader]
  #?(:cljs (cond
             (number? value) (double value)
             (string? value) (edn-reader value)
             :default value)
     :clj
     (cond
       ;; TODO: double? in 1.9 - we have some dependency problems
       ;(double? value) value
       (number? value) (double value)                       ;; can be bigdec -> causes problems in datomic
       ;; TODO: do we ever want to accept any other than numeric values ?
       ;; for example we could have any date format coming to date field that would be converted to epoch ms ?
       (string? value) (edn-reader value)
       :default value
       )))

(defmethod _coerce :data.type/percentage
  [field-schema value edn-reader]
  #?(:cljs (cond
             (number? value) value
             (string? value) (edn-reader value)
             :default value)
     :clj
     (cond
       ;; TODO: double? in 1.9 - we have some dependency problems
       ;(double? value) value
       (number? value) (double value)                       ;; can be bigdec -> causes problems in datomic
       ;; TODO: do we ever want to accept any other than numeric values ?
       ;; for example we could have any date format coming to date field that would be converted to epoch ms ?
       (string? value) (edn-reader value)
       :default value
       )))

(defmethod _coerce :data.type/multiplier
  [field-schema value edn-reader]
  #?(:cljs (cond
             (number? value) value
             (string? value) (edn-reader value)
             :default value)
     :clj
     (cond
       ;; TODO: double? in 1.9 - we have some dependency problems
       ;(double? value) value
       (number? value) (double value)                       ;; can be bigdec -> causes problems in datomic
       ;; TODO: do we ever want to accept any other than numeric values ?
       ;; for example we could have any date format coming to date field that would be converted to epoch ms ?
       (string? value) (edn-reader value)
       :default value
       )))


(defmethod _coerce :data.type/integer
  [field-schema value edn-reader]
  (cond
    (number? value) (long value)
    (string? value) (long (edn-reader value))
    :default value))

(defmethod _coerce :data.type/text-edn
  [field-schema value edn-reader]
  (if (string? value)
    value
    (pr-str value)))

(defmethod _coerce :data.type/financials
  [field-schema value edn-reader]
  (if (string? value)
    value
    (pr-str value)))

(defmethod _coerce :data.type/tesi-financials
  [field-schema value edn-reader]
  (if (string? value)
    value
    (pr-str value)))

(defmethod _coerce :data.type/tesi-financials-2
  [field-schema value edn-reader]
  (if (string? value)
    value
    (pr-str value)))

(defmethod _coerce :data.type/text-url
  [field-schema value edn-reader]
  (cond
    (string? value) (string/trim value)
    :default value))

(defmethod _coerce :data.type/keyword
  [field-schema value edn-reader]
  (cond
    (string? value) (some->> field-schema
                             :options
                             (map (fn [opt]
                                    (when (= (cu/str-trim-lcase (:label opt))
                                             (cu/str-trim-lcase value))
                                      (or (:keyword opt)
                                          (:key opt)))))
                             (first))
    :default value))

(defmethod _coerce :data.type/ref-single
  [field-schema value edn-reader]
  (cond
    (string? value) (edn-reader value)
    (number? value) value
    (map? value) (:db/id value)
    :default value))

(defmethod _coerce :data.type/ref-multi
  [field-schema value edn-reader]
  (cond
    (string? value) (->> (string/split value #";")
                         (map (fn [v]
                                (_coerce (assoc field-schema :field/data-type :data.type/ref-single) v edn-reader)))
                         (vec))
    :default value))

(defn coerce-value
  [field-schema value edn-reader]
  (_coerce field-schema value edn-reader))

(defn trim-value
  [v]
  (string/trim (str v)))

(defmulti _coerce-to-str
          (fn [field-schema _ _ _ _ _]
            (:field/data-type field-schema)))

(defmethod _coerce-to-str :default
  [field-schema value entity tenant lookup opts]
  (trim-value value))

(defmethod _coerce-to-str :data.type/boolean
  [field-schema value entity tenant lookup opts]
  (str value))

(defmethod _coerce-to-str :data.type/ref-multi
  [field-schema value entity tenant lookup opts]
  #?(:cljs (->> value
                (map lookup)
                (map (fn [e]
                       (entity/display-string e :short (or lookup identity))))
                (doall))
     :clj  (->> value
                (map (fn [e]
                       (entity/display-string e :short (or lookup identity))))
                (doall)
                (string/join ", "))))

(defmethod _coerce-to-str :data.type/ref-single
  [field-schema value entity tenant lookup opts]
  (if (:db/id value)
    (entity/display-string value :short (or lookup identity))
    (entity/display-string (lookup value) :short (or lookup identity))))

(defn resolve-opt-label
  [value opt]
  (when (or (= (:keyword opt) value)
            (= (:key opt) value))
    (:label opt)))

(defmethod _coerce-to-str :data.type/keyword
  [field-schema value entity tenant lookup opts]
  (or (->> field-schema
           :options
           (map (partial resolve-opt-label value))
           (remove nil?)
           (first))
      (loc/tr value)))

(defmethod _coerce-to-str :data.type/keyword-multi
  [field-schema value entity tenant lookup opts]
  (->> (if (coll? value)
         value
         [value])
       (map (fn [value]
              (or (->> field-schema
                       :options
                       (map (partial resolve-opt-label value))
                       (remove nil?)
                       (first))
                  (loc/tr value))))
       (cu/flip string/join " | ")))

(defmethod _coerce-to-str :data.type/text-simple
  [field-schema value entity tenant lookup opts]
  (trim-value value))

(defmethod _coerce-to-str :data.type/text-multiline
  [field-schema value entity tenant lookup opts]
  (trim-value value))

(defmethod _coerce-to-str :data.type/currency-value
  [field-schema value entity tenant lookup opts]
  #?(:cljs (str value)
     :clj  (let [currency-label (currencies/get-label (or (get entity
                                                               (->> field-schema
                                                                    :field/secondary-attribute))
                                                          (:tenant/default-currency tenant)))
                 multiplier (or (:tenant/cur-multiplier tenant) "1")
                 thousand-separator (:thousand-separator opts)
                 float-format (str "%,.2f")
                 render-value (if-not value
                                ""
                                (case multiplier
                                  nil (str (format float-format (float (/ value 1000000))))
                                  "" (str (format float-format (float (/ value 1000000))))
                                  "1" (str (format float-format (float (/ value 1000000))))
                                  "m" (str (format float-format (float (/ value 1000000))) "M")
                                  "M" (str (format float-format (float (/ value 1000000))) "M")
                                  "lacs" (str (format float-format (float (/ value 100000))) "Lacs")
                                  "Cr" (str (format float-format (float (/ value 10000000))) "Cr")
                                  "k" (str (format float-format (float (/ value 1000))) "k")
                                  "K" (str (format float-format (float (/ value 1000))) "k")))
                 [whole fraction] (string/split render-value #"\.")
                 correct-separators (str (string/replace whole #"," (str thousand-separator))
                                         (when fraction
                                           (if (= "." thousand-separator)
                                             ","
                                             "."))
                                         (when fraction
                                           fraction))]
             (when (not-empty (trim-value correct-separators))
               (trim-value (str currency-label " " correct-separators))))))

(defmethod _coerce-to-str :data.type/currency-symbol
  [field-schema value entity tenant lookup opts]
  (currencies/get-label value))

(defmethod _coerce-to-str :data.type/date
  [field-schema value entity tenant lookup opts]
  (some-> value
          (date-formats/format-millis
            (or (:tenant/date-format tenant) (loc/tr :date-format))
            (or (:tenant/timezone tenant)
                timezones/default-timezone))))

(defmethod _coerce-to-str :data.type/datetime
  [field-schema value entity tenant lookup opts]
  (some-> value
          (date-formats/format-millis
            (or (:tenant/date-format tenant) (loc/tr :date-format))
            (or (:tenant/timezone tenant)
                timezones/default-timezone))))

(defmethod _coerce-to-str :data.type/number
  [field-schema value entity tenant lookup opts]
  (str value))

(defmethod _coerce-to-str :data.type/integer
  [field-schema value entity tenant lookup opts]
  (str value))

(defmethod _coerce-to-str :data.type/text-edn
  [field-schema value entity tenant lookup opts]
  (if (string? value)
    (trim-value value)
    (pr-str value)))

(defmethod _coerce-to-str :data.type/financials
  [field-schema value entity tenant lookup opts]
  (if (string? value)
    (trim-value value)
    (pr-str value)))

(defmethod _coerce-to-str :data.type/tesi-financials
  [field-schema value entity tenant lookup opts]
  (if (string? value)
    (trim-value value)
    (pr-str value)))

(defmethod _coerce-to-str :data.type/tesi-financials-2
  [field-schema value entity tenant lookup opts]
  (if (string? value)
    (trim-value value)
    (pr-str value)))

(defmethod _coerce-to-str :data.type/text-url
  [field-schema value entity tenant lookup opts]
  (trim-value value))

(defmethod _coerce-to-str :data.type/keyword-multi
  [field-schema value entity tenant lookup opts]
  (let [options-map (->> field-schema
                         :options
                         (map (fn [opt]
                                (cond (keyword? (:key opt))
                                      [(:key opt) (:label opt)]
                                      (string? (:key opt))
                                      [(keyword (:key opt)) (:label opt)]
                                      :else
                                      [(keyword (str opt)) (str opt)])))
                         (into {}))]
    (->> value
         (set)
         (map (fn [v]
                (when-let [label (get options-map v)]
                  label)))
         (remove nil?)
         (string/join ", "))))

(defn coerce-to-str
  [field-schema value entity tenant lookup opts]
  (_coerce-to-str field-schema value entity tenant lookup opts))
